import { getStateCode } from "../../../../../../constant/states";
import {
  UNSPECIFIED_MEMBER_ID,
  UNSPECIFIED_PAYER_NAME,
  UNSPECIFIED_RX_MEMBER_ID
} from "../../../../../../constant/coverages";
import { getPurePhoneNumber } from "../../../../../../utils/misc";
import { insuranceMedicalName } from "./formSections/insuranceConfigurations";
import { drugAssistanceType } from "../../../components/SupportOptions";
// sanitizeAddressLine lives in utils/validationRules.js; mirrors the authoritative
// FN server-side sanitizer (FhirBridgeService). Used here to clean the auto-filled
// address on prefill so the displayed value is already normalized.
import { sanitizeAddressLine } from "../../../utils/validationRules";

const OTHER = "Other";

export const getGenentechCopayFormInitialValues = ({ applicationForm, defaultFacilityNpis }) => {
  const DEFAULT_PHONE_TYPE = "mobile";

  const patientState =
    applicationForm?.formData?.patient?.state === "" ? null : applicationForm?.formData?.patient?.state;

  const insurance = applicationForm?.formData?.insurance;
  const insuranceTypeSelect = insurance?.medical?.planType ? OTHER : null;

  let insuranceNameSelect = null;
  if (insurance?.medical?.name && !insurance.medical.name.startsWith(UNSPECIFIED_PAYER_NAME)) {
    if (insuranceMedicalName.includes(insurance?.medical?.name)) {
      insuranceNameSelect = insurance?.medical?.name;
    } else {
      insuranceNameSelect = OTHER;
    }
  }

  let physicianState = applicationForm?.formData?.physician?.state || null;
  if (physicianState) physicianState = getStateCode(physicianState);

  let facilityState = applicationForm?.formData?.facility?.state || null;
  if (facilityState) facilityState = getStateCode(facilityState);

  const sanitizedGender = ["female", "male", "other"].includes(applicationForm?.formData?.patient?.gender)
    ? applicationForm?.formData?.patient?.gender
    : undefined;

  const initialValues = {
    ...applicationForm?.formData,
    patient: {
      ...applicationForm?.formData?.patient,
      gender: sanitizedGender,
      address: sanitizeAddressLine(applicationForm?.formData?.patient?.address),
      ...(applicationForm?.formData?.patient?.relatedPerson && {
        relatedPerson: {
          ...applicationForm.formData.patient.relatedPerson,
          address: sanitizeAddressLine(applicationForm.formData.patient.relatedPerson.address)
        }
      }),
      state: patientState,
      phoneType: applicationForm?.formData?.patient?.phoneType || DEFAULT_PHONE_TYPE,
      phone: applicationForm?.formData?.patient?.phone
        ? getPurePhoneNumber(applicationForm?.formData?.patient?.phone)
        : null
    },
    physician: {
      ...applicationForm?.formData?.physician,
      address: sanitizeAddressLine(applicationForm?.formData?.physician?.address),
      phone: applicationForm?.formData?.physician?.phone
        ? getPurePhoneNumber(applicationForm?.formData?.physician?.phone)
        : null,
      lastName: applicationForm?.formData?.physician?.lastName || applicationForm?.formData?.physician?.firstName,
      state: physicianState
    },
    facility: {
      ...applicationForm?.formData?.facility,
      address: sanitizeAddressLine(applicationForm?.formData?.facility?.address),
      phone: applicationForm?.formData?.facility?.phone
        ? getPurePhoneNumber(applicationForm?.formData?.facility?.phone)
        : null,
      state: facilityState,
      npi: (defaultFacilityNpis || {})["genentech-copay"] || applicationForm?.formData?.facility?.npi
    },
    insurance: {
      ...insurance,
      medical: {
        ...insurance?.medical,
        selectPlanType: insuranceTypeSelect,
        selectName: insuranceNameSelect,
        memberId: insurance?.medical?.memberId?.startsWith(UNSPECIFIED_MEMBER_ID) ? null : insurance?.medical?.memberId
      },
      pharmacy: {
        ...insurance?.pharmacy,
        name: insurance?.pharmacy?.name?.startsWith(UNSPECIFIED_PAYER_NAME) ? null : insurance?.pharmacy?.name,
        memberId:
          typeof insurance?.pharmacy?.memberId === "string" &&
          insurance?.pharmacy?.memberId.startsWith(UNSPECIFIED_RX_MEMBER_ID)
            ? null
            : insurance?.pharmacy?.memberId
      }
    },
    assistanceType: applicationForm?.formData?.assistanceType ?? [drugAssistanceType]
  };

  return initialValues;
};
